export const defaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  marketingOptIn: true,
};
